import { createContext, useContext } from "react";

interface TourSlideContextProps {
  key: number;
}

export const TourSlideContext = createContext<TourSlideContextProps>({ key: -1 });
export const useTourSlideContext = (): TourSlideContextProps => useContext<TourSlideContextProps>(TourSlideContext);
